<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card gps-card">
					<div class="card-header card-header-{{ color }}-1">
						<h4 class="card-title d-flex align-items-center">
							<mat-icon class="mr-2 cursor-pointer" (click)="back()">arrow_back</mat-icon>
							General Posting Setup
						</h4>
						<p class="card-category text-right">Link posting groups to GL accounts.</p>
					</div>

					<div class="card-body gps-body">
						<header class="gps-toolbar">
							<div class="gps-search">
								<mat-icon class="gps-search__icon">search</mat-icon>
								<input
									type="text"
									class="gps-search__input"
									placeholder="Search code, description or account…"
									[(ngModel)]="searchTerm"
									name="gpsSearch" />
								<button type="button" class="gps-search__clear" *ngIf="searchTerm" (click)="searchTerm=''" aria-label="Clear">
									<mat-icon>close</mat-icon>
								</button>
							</div>
							<div class="gps-toolbar__actions">
								<span class="gps-chip">{{ rows.length }} total</span>
								<span class="gps-chip gps-chip--accent" *ngIf="searchTerm">{{ filteredRows().length }} matching</span>
								<button mat-stroked-button type="button" *ngIf="rows.length" (click)="exportExcel()">
									<mat-icon>file_download</mat-icon>
									Export
								</button>
								<button mat-raised-button [color]="color" type="button" (click)="openNew()">
									<mat-icon>add</mat-icon>
									New row
								</button>
							</div>
						</header>

						<div class="gps-loading" *ngIf="isLoading">
							<mat-spinner diameter="32"></mat-spinner>
							<span>Loading posting setup…</span>
						</div>

						<div class="gps-tablewrap" *ngIf="!isLoading">
							<table class="gps-table">
								<thead>
									<tr>
										<th class="gps-th-bus">Bus.</th>
										<th class="gps-th-prod">Product</th>
										<th>Description</th>
										<th class="gps-th-acct">Sales</th>
										<th class="gps-th-acct">COGS</th>
										<th class="gps-th-acct">COGS Int.</th>
										<th class="gps-th-acct">Inv. Adj.</th>
										<th class="gps-th-status">Status</th>
										<th class="gps-th-actions"></th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let r of filteredRows(); trackBy: trackByRow"
										class="gps-row"
										[class.gps-row--blocked]="r.blocked == 1 || r.blocked === true || r.blocked === '1'"
										[class.gps-row--editing]="editingRow === r"
										(dblclick)="editRow(r)">
										<td><span class="gps-pill gps-pill--bus">{{ r.gen_bus_posting_group }}</span></td>
										<td><span class="gps-pill gps-pill--prod">{{ r.gen_prod_posting_group }}</span></td>
										<td class="gps-cell-desc">{{ r.description || '—' }}</td>
										<td class="gps-mono">{{ r.sales_account || '—' }}</td>
										<td class="gps-mono">{{ r.cogs_account || '—' }}</td>
										<td class="gps-mono">{{ r.cogs_account_interim || '—' }}</td>
										<td class="gps-mono">{{ r.inventory_adjmt_account || '—' }}</td>
										<td>
											<span class="gps-status gps-status--blocked" *ngIf="r.blocked == 1 || r.blocked === true || r.blocked === '1'">Blocked</span>
											<span class="gps-status gps-status--active" *ngIf="!(r.blocked == 1 || r.blocked === true || r.blocked === '1')">Active</span>
										</td>
										<td class="gps-actions">
											<button type="button" class="gps-iconbtn" (click)="editRow(r)" title="Edit">
												<mat-icon>edit</mat-icon>
											</button>
											<button type="button" class="gps-iconbtn" (click)="cloneRow(r)" title="Duplicate">
												<mat-icon>content_copy</mat-icon>
											</button>
											<button type="button" class="gps-iconbtn gps-iconbtn--danger" (click)="deleteRow(r)" title="Delete">
												<mat-icon>delete</mat-icon>
											</button>
										</td>
									</tr>
									<tr *ngIf="!filteredRows().length">
										<td colspan="9" class="gps-empty">No rows match the current filter.</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<aside class="gps-drawer" [class.gps-drawer--open]="isFormVisible">
		<div class="gps-drawer__scrim" (click)="closeForm()"></div>
		<form class="gps-drawer__panel" [formGroup]="form" (ngSubmit)="save()">
			<header class="gps-drawer__header card-header-{{ color }}-1">
				<div>
					<h3 class="gps-drawer__title">{{ editingRow ? 'Edit posting row' : 'New posting row' }}</h3>
					<p class="gps-drawer__subtitle">
						<ng-container *ngIf="editingRow">
							{{ editingRow.gen_bus_posting_group }} · {{ editingRow.gen_prod_posting_group }}
						</ng-container>
						<ng-container *ngIf="!editingRow">
							New business and product pair.
						</ng-container>
					</p>
				</div>
				<button type="button" class="gps-iconbtn gps-iconbtn--onaccent" (click)="closeForm()" aria-label="Close">
					<mat-icon>close</mat-icon>
				</button>
			</header>

			<section class="gps-drawer__body">
				<div class="gps-grid gps-grid--3">
					<label class="gps-field">
						<span class="gps-field__label">Business group <em>*</em></span>
						<input class="gps-field__input" formControlName="gen_bus_posting_group" maxlength="20" placeholder="e.g. GLOBAL" />
					</label>
					<label class="gps-field">
						<span class="gps-field__label">Product group <em>*</em></span>
						<input class="gps-field__input" formControlName="gen_prod_posting_group" maxlength="20" placeholder="e.g. EDUCATION" />
					</label>
					<label class="gps-field gps-field--toggle">
						<span class="gps-field__label">Status</span>
						<div class="gps-toggle">
							<mat-slide-toggle formControlName="blocked" color="warn">
								<span class="gps-toggle__label">{{ form.value.blocked ? 'Blocked' : 'Active' }}</span>
							</mat-slide-toggle>
						</div>
					</label>
					<label class="gps-field gps-field--span3">
						<span class="gps-field__label">Description</span>
						<input class="gps-field__input" formControlName="description" maxlength="100" placeholder="What is this combination for?" />
					</label>
				</div>

				<div class="gps-copyfrom" *ngIf="rows.length">
					<div class="gps-copyfrom__header">
						<mat-icon>content_copy</mat-icon>
						<div>
							<div class="gps-copyfrom__title">Copy accounts from another row</div>
							<div class="gps-copyfrom__hint" *ngIf="!lastCopiedFrom">
								Pre-fill all 21 GL accounts from an existing posting combination.
							</div>
							<div class="gps-copyfrom__hint gps-copyfrom__hint--success" *ngIf="lastCopiedFrom">
								<mat-icon>check_circle</mat-icon>
								Copied from <strong>{{ lastCopiedFrom.bus }} · {{ lastCopiedFrom.prod }}</strong>
							</div>
						</div>
					</div>
					<div class="gps-copyfrom__inputwrap">
						<input
							type="text"
							class="gps-field__input gps-copyfrom__input"
							placeholder="Search by code or description…"
							[formControl]="copySourceCtrl"
							[matAutocomplete]="copyAuto" />
						<mat-autocomplete
							#copyAuto="matAutocomplete"
							[displayWith]="displayCopySource"
							class="gps-autocomplete"
							(optionSelected)="onCopySourceSelected($event)">
							<mat-option *ngFor="let s of filteredCopySources | async; trackBy: trackByRow" [value]="s">
								<span class="gps-opt-code">{{ s.gen_bus_posting_group }} · {{ s.gen_prod_posting_group }}</span>
								<span class="gps-opt-name">{{ s.description || '—' }}</span>
							</mat-option>
						</mat-autocomplete>
					</div>
				</div>

				<nav class="gps-tabs" role="tablist">
					<button
						*ngFor="let t of groupTabs"
						type="button"
						role="tab"
						[attr.aria-selected]="activeGroup === t.id"
						class="gps-tab"
						[class.gps-tab--active]="activeGroup === t.id"
						(click)="activeGroup = t.id">
						<mat-icon>{{ t.icon }}</mat-icon>
						<span>{{ t.label }}</span>
						<span class="gps-tab__count">{{ groupAssignedCount(t.id) }}/{{ groupCount(t.id) }}</span>
					</button>
				</nav>

				<div class="gps-grid gps-grid--2 gps-accounts">
					<div class="gps-acct" *ngFor="let f of visibleAccountFields; trackBy: trackByKey">
						<label class="gps-acct__label">{{ f.label }}</label>
						<div class="gps-acct__inputwrap">
							<input
								type="text"
								class="gps-field__input gps-acct__input"
								[matAutocomplete]="auto"
								[formControlName]="f.key"
								[placeholder]="'GL account'" />
							<button
								type="button"
								class="gps-acct__clear"
								*ngIf="form.get(f.key)?.value && form.get(f.key)?.value !== '0'"
								(click)="form.get(f.key)?.setValue('0')"
								title="Reset to default">
								<mat-icon>close</mat-icon>
							</button>
							<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayGl" class="gps-autocomplete">
								<mat-option *ngFor="let opt of filtered[f.key] | async; trackBy: trackByCode" [value]="opt.code">
									<span class="gps-opt-code">{{ opt.code }}</span>
									<span class="gps-opt-name">{{ opt.name }}</span>
								</mat-option>
							</mat-autocomplete>
						</div>
						<span class="gps-acct__resolved" *ngIf="form.get(f.key)?.value && form.get(f.key)?.value !== '0'">
							{{ glLabel(form.get(f.key)?.value) }}
						</span>
					</div>
				</div>
			</section>

			<footer class="gps-drawer__footer">
				<button mat-stroked-button type="button" (click)="closeForm()">Cancel</button>
				<button mat-raised-button [color]="color" type="submit" [disabled]="form.invalid">
					<mat-icon>save</mat-icon>
					{{ editingRow ? 'Update row' : 'Add row' }}
				</button>
			</footer>
		</form>
	</aside>
</div>
